export default "__VITE_ASSET__T6X0omMY__"